import React, { useState, useEffect } from "react";
import {
  TextField,
  FormControl,
  Checkbox,
  Button,
  Grid,
  Card,
} from "@material-ui/core";
import api from "../../api";
import utils from "../../utils/utils";
import { CustomerTypeEnum, PaymentMethodTypes } from "../../enums/enums";
import iconLogo from "../../img/logoFull.png";
import TermsAndConditions from "./components/Confirm/TermsAndConditions";
import Confirmed from "./components/Confirm/Confirmed";
import { useParams } from "react-router-dom";

export default function AgreementConfirm({ setIsLoading }) {
  let { hash } = useParams();
  const [loading, setLoading] = useState(true);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [hasOtpIncluded, setHasOtpIncluded] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [checkTerms, setCheckTerms] = useState(false);
  const [certificateButton, setCertificateButton] = useState(false);
  const [agreementData, setAgreementData] = useState({
    id: undefined,
    hash: undefined,
    otp: undefined,
  });

  const confirm = () => {
    setIsConfirm(true);
    setIsLoading(true);

    let security = {
      codigo: agreementData.otp ? parseInt(agreementData.otp) : undefined,
    };

    api
      .confirmAgreementWithHash(agreementData.hash, security)
      .then((res) => {
        setIsConfirmed(true);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsConfirm(false);
        setIsLoading(false);
        let message = "Ocurrió un error";
        if (err.response.data.errores) {
          message = err.response.data.errores[0];
        }

        utils.alertError("Contrato N° " + agreementData.id, message);
      });
  };

  function validation() {
    let response = true;

    if (!isConfirm) {
      if (hasOtpIncluded) {
        if (checkTerms) response = false;
      } else if (agreementData.otp && checkTerms) response = false;
    }

    return response;
  }

  const closeDialog = () => {
    setDialogOpen(false);
  };

  function openCertificate() {
    setIsLoading(true);
    setCertificateButton(true);
    api
      .getAgreementCertificate(
        agreementData.id,
        agreementData.hash,
        agreementData.otp
      )
      .then((res) => {
        var file = new Blob([res.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);

        setIsLoading(false);
        setTimeout(() => {
          setCertificateButton(false);
        }, 3000);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    setIsLoading(true);
    api
      .checkAgreementHash(hash)
      .then((res) => {
        let data = res.data;
        let customerData = data.cliente;
        let customer = {
          firstName: customerData.nombre?.toUpperCase(),
          lastName: customerData.apellido?.toUpperCase(),
          documentNumber: customerData.numeroDocumento,
          state: customerData.provincia.toUpperCase(),
          city: customerData.localidad.toUpperCase(),
          zip: customerData.codigoPostal,
          email: customerData.email,
          isBusiness: customerData.esEmpresa,
          businessName: customerData.razonSocial?.toUpperCase(),
        };

        let productData = data.producto;
        let product = {
          price: String(productData.precio).replace(".", ","),
          category: productData.categoria,
          categoryColor: productData.categoriaColor,
          termsAndConditions: productData.rutaPdf,
        };

        let paymentData = data.metodoDePago;
        let paymentNumber;
        if (paymentData.tipoMedioPagoId !== PaymentMethodTypes.CBU.Id) {
          paymentNumber = paymentData.numeroTarjeta;
        } else {
          paymentNumber = paymentData.cbu;
        }

        let payment = {
          number: paymentNumber,
          name: paymentData.medioPago,
          text: paymentData.medioPago + " " + paymentNumber,
        };

        setAgreementData({
          id: data.contratoId,
          hash: data.hash,
          customer: customer,
          product: product,
          payment: payment,
        });
        setHasOtpIncluded(data.otpCode ? true : false);
        setLoading(false);
        setIsLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setIsLoading(false);
      });
  }, []);

  const AgreementItem = ({ Name, Text, ClassName, Color }) => {
    let classNameRight = "c-agc-card-body-item-right ";
    let classNameLeft = "c-agc-card-body-item-left ";
    let style;
    if (ClassName) {
      classNameLeft += "c-mt-20";
      classNameRight += ClassName;
      style = { color: Color };
    }

    return (
      <Grid className="c-agc-card-body-item" item xs={12} md={12}>
        <Grid container>
          <Grid className={classNameLeft} item xs={12} md={6}>
            <h4>{Name}</h4>
          </Grid>
          <Grid className={classNameRight} style={style} item xs={12} md={6}>
            <h4>{Text}</h4>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {!loading && (
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          className="c-login"
        >
          <Grid className="c-w-100 c-p-25" item md={5} xs={8}>
            {agreementData.id && !isConfirmed ? (
              <>
                <Card className="c-agc-card" elevation={3}>
                  <Grid className="c-agc-card-header" container>
                    <Grid item xs={12} md={12}>
                      <h4>Confirmar Contratación</h4>
                    </Grid>
                  </Grid>
                  <Grid className="c-agc-card-body" container>
                    <Grid
                      className="c-agc-card-body-header"
                      item
                      xs={12}
                      md={12}
                    >
                      <img className="img" src={iconLogo} />
                      <Grid className="c-mt-25 c-mb-25" container>
                        <Grid item xs={12} md={12}>
                          <h5 className="c-title-price">Valor cuota</h5>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <h2 className="c-price">
                            ${agreementData.product.price}
                          </h2>
                        </Grid>
                      </Grid>
                    </Grid>
                    <AgreementItem
                      Name="Compañia de asistencia"
                      Text="S.O.S SA"
                    />
                    <AgreementItem
                      Name="Plan"
                      Text={agreementData.product.category}
                      ClassName="c-agc-card-body-item-right-plan"
                      Color={agreementData.product.categoryColor}
                    />
                    <AgreementItem
                      Name="Medio de Pago"
                      Text={agreementData.payment.text}
                    />
                    <Grid
                      className="c-agc-card-body-title"
                      item
                      xs={12}
                      md={12}
                    >
                      <h4>Datos</h4>
                    </Grid>
                    <AgreementItem
                      Name={
                        agreementData.customer.isBusiness ===
                        CustomerTypeEnum.FinalCustomer
                          ? "Nombre y Apellido"
                          : "Razón Social"
                      }
                      Text={
                        agreementData.customer.isBusiness ===
                        CustomerTypeEnum.FinalCustomer
                          ? agreementData.customer.firstName +
                            " " +
                            agreementData.customer.lastName
                          : agreementData.customer.businessName
                      }
                    />
                    <AgreementItem
                      Name={
                        agreementData.customer.isBusiness ===
                        CustomerTypeEnum.FinalCustomer
                          ? "DNI"
                          : "CUIT"
                      }
                      Text={agreementData.customer.documentNumber}
                    />
                    <AgreementItem
                      Name="Provincia"
                      Text={agreementData.customer.state}
                    />
                    <AgreementItem
                      Name="Localidad"
                      Text={agreementData.customer.city}
                    />
                    <AgreementItem
                      Name="Código Postal"
                      Text={agreementData.customer.zip}
                    />
                    <AgreementItem
                      Name="Email"
                      Text={agreementData.customer.email}
                    />

                    {!hasOtpIncluded && (
                      <Grid
                        className="c-agc-card-body-otp"
                        item
                        xs={12}
                        md={12}
                      >
                        <FormControl>
                          <TextField
                            id="outlined-basic"
                            label="Código de Activación"
                            variant="outlined"
                            onChange={(e) => {
                              setAgreementData({
                                ...agreementData,
                                otp: e.target.value,
                              });
                            }}
                            inputProps={{ min: 0, autocomplete: "off" }}
                            type="number"
                          />
                        </FormControl>
                      </Grid>
                    )}

                    <Grid
                      className="c-agc-card-body-terms"
                      item
                      xs={12}
                      md={12}
                    >
                      <Grid container>
                        <Grid
                          className="c-agc-card-body-terms-left"
                          item
                          xs={8}
                          md={6}
                        >
                          <h4
                            onClick={() => {
                              if (agreementData.product.termsAndConditions)
                                window.open(
                                  agreementData.product.termsAndConditions,
                                  "_blank"
                                );
                            }}
                          >
                            Acepta <strong>Términos y Condiciones</strong>
                          </h4>
                        </Grid>
                        <Grid
                          className="c-agc-card-body-terms-right"
                          item
                          xs={4}
                          md={6}
                        >
                          <Checkbox
                            className="c-checkbox-primary-confirm"
                            checked={checkTerms}
                            onClick={() => setCheckTerms(!checkTerms)}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid className="c-agc-card-body-btn" item xs={12} md={12}>
                      <Button
                        disabled={validation()}
                        className="c-btn-primary-confirm"
                        variant="contained"
                        onClick={confirm}
                      >
                        Continuar
                      </Button>
                    </Grid>
                  </Grid>
                </Card>

                <TermsAndConditions
                  dialogOpen={dialogOpen}
                  closeDialog={closeDialog}
                />
              </>
            ) : (
              <>
                {isConfirmed ? (
                  <Confirmed
                    AgreementNumber={agreementData.id}
                    GetCertificate={openCertificate}
                    CertificateButton={certificateButton}
                  />
                ) : (
                  <Card className="c-agc-card" elevation={3}>
                    <Grid className="c-agc-card-body c-mb-15" container>
                      <Grid item xs={12} md={12}>
                        <h4 className="c-text-center">El contrato no existe</h4>
                      </Grid>
                    </Grid>
                  </Card>
                )}
              </>
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
}
